import { domToPng } from 'modern-screenshot'

import { SALES_REPORT_GRAPH_ELEMENT_ID } from '../../../../../constants/salesReportGraphElementId'

const IMAGE_UPSCALE = 2

export const getSalesReportGraphImageSrc = async () => {
  const graphElement = document.getElementById(SALES_REPORT_GRAPH_ELEMENT_ID)
  if (!graphElement) {
    return undefined
  }

  return await domToPng(graphElement, {
    scale: IMAGE_UPSCALE,
  })
}
